<template>
    <div>
        <div class="ql-editor" v-html="memberData.content"></div>

    </div>
</template>

<script>
export default {
    name: 'VideoContent',
    components: {

    },
    data() {
        return {
            content: "",
            memberData: '',
        }
    },
    methods: {
        // 获取数据列表
        getDataList() {
            this.memberData = this.$route.params.data
            let content = this.memberData.content
            // let c1 = content.replace(/<img width="100%;"/g, '<img');
            // let c2 = c1.replace(/<img/g, '<img width="100%"');
            // this.videoData.content = c2;

        },
       
    },
    created() {
        console.log(this.$route.params.data);
        this.getDataList()
    },

}
</script>

<style lang="less"></style>